import React, { useEffect, useRef, useState } from "react";
import * as XLSX from "xlsx";
import { motion, AnimatePresence } from "motion/react";
import { fetchScreenTranslations } from "../../utils/helpers/translations";
import { useHistory } from "react-router-dom";
import "../../assets/styles/local/AddMaterials.css";
import { Row, Col } from "react-bootstrap";
import DownArrowOption from "../../assets/icons/DownArrowOption.svg";
import bin from "../../assets/icons/Bin.svg";
import CardAddButton from "../../assets/icons/CardAddButton.svg";
import shared from "../../assets/icons/shared.svg";
import Xcircle from "../../assets/icons/x-circle.svg";
import Xicon from "../../assets/icons/Xicon.svg";
import Kebab from "../..//assets/icons/Kebab contacts.svg";
import docicons from "../../assets/icons/Document-2.svg";
import Package_icon from "../../assets/icons/package_icon.svg";
import shoppingCart from "../../assets/icons/shopping-cart.svg";
import pdf_icon from "../../assets/icons/pdf_icon.svg";
import printimg from "../../assets/icons/Printimg.svg";
import XiconCircle from "../../assets/icons/x-circle.svg";
import upArrow from "../../assets/icons/upArrow.png";
import Loader from "../../components/Dailogs/Loader";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import Attention from "../../assets/icons/Attention.svg";
import { styled } from "@mui/material/styles";
import {
  AddPhaseMaterials,
  FetchPhaseMaterialsByProject,
  DeletePhase,
  DeleteMaterials,
  FetchMaterialList,
} from "../../redux/actions/action";
import { FETCH_MATERIALS_LIST } from "../../redux/constants/type";
import { useDispatch, useSelector } from "react-redux";

var totalSubIndex = 0;

const AddMaterials = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const kebab_Popup_Ref = useRef(null);
  const sortByRef = useRef(null);
  const createSublistPopupRef = useRef(null);
  const pickStockPopupRef = useRef(null);
  const addPurchasePopupRef = useRef(null);
  const makeCheckListPopupRef = useRef(null);
  const qtySubListPopupRef = useRef(null);
  const roleAccess = window.localStorage.getItem("roleid");
  const projectid = window.localStorage.getItem("projectid");
  const projectcode = window.localStorage.getItem("projectcode");

  const addPhaseMaterialsRes = useSelector(
    (state) => state.user.addPhaseMaterialsRes,
  );

  const fetchPhaseMaterialsByProjectRes = useSelector(
    (state) => state.user.fetchPhaseMaterialsByProjectRes,
  );

  const deletePhaseRes = useSelector((state) => state.user.deletePhaseRes);

  const deleteMaterialsRes = useSelector(
    (state) => state.user.deleteMaterialsRes,
  );

  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || "";
  useEffect(() => {
    fetchScreenTranslations("Add-Project").then((data) =>
      setFetchTranslationList(data),
    );
  }, []);

  // variables state management start
  const [showLoader, setShowLoader] = useState(true);
  const [materialsList, setMaterialsList] = useState([]);
  const [kebabPopupShow, setKebabPopupShow] = useState(false);

  // Header hiring update variables for kebab start.
  const [selectedPhaseID, setSelectedPhaseID] = useState("");
  const [createSublistPopup, setCreateSublistPopup] = useState(false);
  // pick from stock start.
  const [arrowOptionsRotate3, setArrowOptionsRotate3] = useState(false);
  const [pickFromStockShow, setPickFromStockShow] = useState(false);
  const [pickFromStock, setPickFromStock] = useState("");
  // pick from stock end.

  // add purchase start.
  const [arrowOptionsRotate7, setArrowOptionsRotate7] = useState(false);
  const [addPurchaseShow, setAddPurchaseShow] = useState(false);
  const [addPurchase, setAddPurchase] = useState("");
  // add purchase end.

  // make checklist start.
  const [arrowOptionsRotate8, setArrowOptionsRotate8] = useState(false);
  const [makeCheckListShow, setMakeCheckListShow] = useState(false);
  const [makeCheckList, setMakeCheckList] = useState("");
  // make checklist end.

  const [phasePopupShow, setPhasePopupShow] = useState(false);
  const [pickStockPopup, setPickStockPopup] = useState(false);

  // header pagination start 2nd.
  const [pageNumber, setPageNumber] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  // header pagination end 2nd.
  useEffect(() => {
    if (fetchPhaseMaterialsByProjectRes.status === true) {
      setMaterialsList(fetchPhaseMaterialsByProjectRes.data);
      setShowLoader(false);

      // header pagination start 2nd.
      let pages = Math.ceil(
        fetchPhaseMaterialsByProjectRes?.totalCount / itemsPerPage,
      );
      setTotalPages(pages);
      setTotalItems(fetchPhaseMaterialsByProjectRes?.totalCount);
      let array = [];
      for (let i = 1; i <= pages; i++) {
        array.push(i);
      }
      // header pagination end 2nd.
    }
  }, [fetchPhaseMaterialsByProjectRes]);

  /// ASC CLOSE DROP DOWN CLICK OUT SIDE START ///
  useEffect(() => {
    document.addEventListener("click", handleClickOutside, false);
    return () => {
      document.removeEventListener("click", handleClickOutside, false);
    };
  }, []);

  const handleClickOutside = (event) => {
    if (
      kebab_Popup_Ref.current &&
      !kebab_Popup_Ref.current.contains(event.target)
    ) {
      setKebabPopupShow(false);
      setArrowOptionsRotate(false);
    }

    if (sortByRef.current && !sortByRef.current.contains(event.target)) {
      setShowShortDrop(false);
    }

    if (
      createSublistPopupRef.current &&
      !createSublistPopupRef.current.contains(event.target)
    ) {
      // setCreateSublistPopup(false);
    }

    if (
      pickStockPopupRef.current &&
      !pickStockPopupRef.current.contains(event.target)
    ) {
      // setPickStockPopup(false);
    }

    if (
      addPurchasePopupRef.current &&
      !addPurchasePopupRef.current.contains(event.target)
    ) {
      // setAddPurchasePopup(false);
    }

    if (
      makeCheckListPopupRef.current &&
      !makeCheckListPopupRef.current.contains(event.target)
    ) {
      // setMakeCheckListPopup(false);
    }

    if (
      qtySubListPopupRef.current &&
      !qtySubListPopupRef.current.contains(event.target)
    ) {
      setQtySplitDataPopup(false);
    }
  };
  /// ASC CLOSE DROP DOWN CLICK OUT SIDE END ///
  const [arrowOptionsRotate, setArrowOptionsRotate] = useState(false);
  const [sortBy, setSortBy] = useState("");
  const [querystring, setQuerystring] = useState("");
  const [isUpdateTime, setIsUpdateTime] = useState(false);

  // for sort by
  const [shortByArrow, setShortByArrow] = useState(false);
  const [showShortDrop, setShowShortDrop] = useState(false);
  const [sortedValue, setSortedValue] = useState("Start Date");

  // sort by options start
  const sortByOption = [
    { label: "Start Date", value: "Start Date" },
    { label: "End Date", value: "End Date" },
    { label: "Assignee", value: "Assignee" },
    { label: "Equipment", value: "Equipment" },
  ];
  // sort by options end

  useEffect(() => {
    const sortedPayload = shortByArrow
      ? `asc-${sortedValue}`
      : `dsc-${sortedValue}`;
    // dispatch(FetchProjectWorks(querystring, sortedPayload));
    // dispatch(FetchPOByProject(projectid, "Rent"));
    // dispatch(FetchPhaseMaterialsByProject(projectid, pageNumber, itemsPerPage));
    dispatch(FetchPhaseMaterialsByProject(projectid));
  }, [
    addPhaseMaterialsRes,
    deletePhaseRes,
    deleteMaterialsRes,
    querystring,
    sortBy,
    shortByArrow,
    sortedValue,
    pageNumber,
  ]);

  const [importCadPopup, setImportCadPopup] = useState(false);
  const [addPurchasePopup, setAddPurchasePopup] = useState(false);
  const [makeCheckListPopup, setMakeCheckListPopup] = useState(false);
  const [phaseName, setPhaseName] = useState("");
  const [allUnit, setAllUnit] = useState("");
  const [totalQuantity, setTotalQuantity] = useState("");
  const [totalOfSheet, setTotalOfSheet] = useState("");
  const [isOrderPick, setIsOrderPick] = useState(false);

  // for Qty.Sublist start
  const [qtySplitDataPopup, setQtySplitDataPopup] = useState(false);
  const [arrowOptionsRotate4, setArrowOptionsRotate4] = useState(false);
  const [qtySplitDataList, setQtySplitDataList] = useState([
    {
      id: "2",
      name: "2",
      default: true,
    },

    {
      id: "3",
      name: "3",
    },

    {
      id: "4",
      name: "4",
    },

    // {
    //   id: "5",
    //   name: "5",
    // },
  ]);
  const [qtySplitData, setQtySplitData] = useState(qtySplitDataList[0].name);
  const [qtySplitDataID, setQtySplitDataID] = useState(qtySplitDataList[0].id);
  // for Qty.Sublist end.

  // for Split start.
  const [splitDataPopup, setSplitDataPopup] = useState(false);
  const [arrowOptionsRotate5, setArrowOptionsRotate5] = useState(false);
  const [splitDataList, setSplitDataList] = useState([
    {
      id: "1",
      name: "Divide equal",
    },

    {
      id: "2",
      name: "Custom",
    },
  ]);
  const [splitData, setSplitData] = useState("");
  const [splitDataID, setSplitDataID] = useState("");
  // for Split end.

  // for Use List start.
  const [useListDataPopup, setUseListDataPopup] = useState(false);
  const [arrowOptionsRotate6, setArrowOptionsRotate6] = useState(false);
  const [useListDataList, setUseListDataList] = useState([
    {
      id: "1",
      name: "1",
    },

    {
      id: "2",
      name: "2",
    },
    {
      id: "3",
      name: "3",
    },
    {
      id: "4",
      name: "4",
    },
    {
      id: "all",
      name: "All",
    },
  ]);
  const [useListData, setUseListData] = useState(useListDataList[0].name);
  const [useListDataID, setUseListDataID] = useState(useListDataList[0].id);
  // for Use List end.

  const handleAddMaterilas = (item) => {
    let materials = xlExtractDataList.map((x, index) => ({
      materialName: x.Onderdeel,
      unit: x.kg,
      quantity: x.Aantal,
      total: x.Totaal,
      articalNumber: x["art, nr,"],
      indexPosition: index,
      isDelete: 0,
    }));
    dispatch(
      AddPhaseMaterials(
        projectid,
        phaseName,
        fileData.name,
        fileData.size,
        allUnit,
        totalQuantity,
        totalOfSheet,
        isOrderPick,
        materials,
      ),
    );

    setTimeout(() => {
      setPhaseName("");
      setFileData({
        name: "",
        size: "",
      });
    }, 1000);
  };

  // selecting File data start.
  const fileRef = useRef(null);
  const fileRef22 = useRef(null);

  const onAttachemntClick = () => {
    fileRef.current?.click();
  };

  const onAttachemntClick22 = () => {
    fileRef22.current?.click();
  };

  const [fileData, setFileData] = useState({
    name: "",
    size: "",
  });

  const [xlExtractDataPopup, setXlExtractDataPopup] = useState(false);
  const [xlExtractDataList, setXlExtractDataList] = useState([]);

  const [isExtracted, setIsExtracted] = useState(false);

  const handleFileExtract = (event) => {
    const file = event.target.files[0];
    if (file) {
      setFileData({
        name: file.name, // Extract the file name
        size: file.size, // Extract the file size
      });
      const reader = new FileReader();

      reader.onload = (e) => {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: "array" });

        // Extract data from the first sheet
        const sheetName = workbook.SheetNames[0];
        const sheet = workbook.Sheets[sheetName];
        const jsonData = XLSX.utils.sheet_to_json(sheet);

        setIsExtracted(true);
        setTimeout(() => {
          setIsExtracted(false);
        }, 5000);
        setXlExtractDataList(jsonData);

        // Calculate total quantity of under data sheet
        let totalOfQty = 0;
        let totalNum = 0;
        let totalKg = 0;
        jsonData.forEach((row) => {
          // Sum quantity
          if (row.Aantal) {
            totalOfQty += parseFloat(row.Aantal) || 0;
          }
          // Sum total of Total
          if (row.Totaal) {
            totalNum += parseFloat(row.Totaal) || 0;
          }
          // Sum of all kg
          if (row.kg) {
            totalKg += parseFloat(row.kg) || 0;
          }
        });

        setTotalQuantity(totalOfQty); // Update the total quantity
        setTotalOfSheet(totalNum); // Update the total of Total
        setAllUnit(totalKg); // Update the total of kg
      };

      reader.readAsArrayBuffer(file);
    }
  };

  // State to hold the SubtotalofQty
  const [subtotalQty, setSubtotalQty] = useState(0);
  const [subtotal2, setSubtotal2] = useState(0);

  const fetchMaterialListRes = useSelector(
    (state) => state.user.fetchMaterialListRes,
  );

  useEffect(() => {
    if (fetchMaterialListRes.status === true) {
      const val = Math.ceil(
        fetchMaterialListRes?.data[0]?.phaseMaterials[0]?.materialQuantity
          ?.length ?? 0,
      );
      totalSubIndex = val;
      dispatch({
        type: FETCH_MATERIALS_LIST,
        data: {},
      });
    }
  }, [dispatch, fetchMaterialListRes]);

  useEffect(() => {
    if (selectedPhaseID) {
      dispatch(FetchMaterialList(selectedPhaseID));
    }
  }, [dispatch, selectedPhaseID]);

  return (
    <>
      {showLoader === true ? (
        <div
          className="text-center "
          style={{ color: "#003766", fontSize: "14px", fontWeight: "700" }}
        >
          <Loader />
        </div>
      ) : (
        <div className="parent pt-2 position-relative">
          {isExtracted && (
            <div className="ocr-page-loader">
              <Loader />
            </div>
          )}
          <div className="outer w-100">
            <Row className="row-item px-4 pb-2">
              <Col xl={3} className="p-0">
                <div
                  onClick={() => {
                    setPhasePopupShow(true);
                  }}
                  className={
                    roleAccess === process.env.REACT_APP_IS_VIEWER
                      ? "pointer d-none position-relative"
                      : "pointer d-flex gap-2 p-3 pb-0 position-relative"
                  }
                  style={{ borderRadius: "8px" }}
                >
                  <img src={CardAddButton} className="addDocImg" alt="" />
                  <p className="createWork pt-1">
                    {/* Add Phase */}
                    {t("Add Phase")}
                  </p>
                </div>
              </Col>

              {/* Add Phase Popup start*/}
              {phasePopupShow && (
                <div className="popup-material">
                  <div className="d-flex gap-2 justify-content-end">
                    <img
                      src={Xcircle}
                      className="addDocImg_add pointer"
                      alt="Add Icon"
                      onClick={() => {
                        setPhasePopupShow(false);
                      }}
                    />
                  </div>
                  <div className="material-input-container" id="materialInput">
                    <label className="material-label-top materialNameText">
                      <span>{t("Phase Name ")}</span>
                      <span className="mandatory-sign">*</span>
                    </label>
                    <input
                      type="text"
                      className={"materialNameInput ps-4 bordered-inputs"}
                      placeholder={t("Add a Name")}
                      value={phaseName}
                      onChange={(e) => {
                        setPhaseName(e.target.value);
                      }}
                    />
                  </div>
                  <div className="material-input-container" id="materialInput">
                    <label className="material-label-top materialNameText">
                      <span>{t("List of Material")}</span>
                    </label>
                    <input
                      type="text"
                      readOnly
                      className="materialNameInput ps-4 bordered-inputs"
                      placeholder={t("Select your XL File ")}
                      value={fileData.name}
                      onChange={(e) => {}}
                      onClick={onAttachemntClick}
                    />
                    <input
                      type="file"
                      ref={fileRef}
                      className="d-none"
                      // accept="image/*"
                      // accept=".pdf"
                      accept=".xls,.xlsx,.xml,.csv"
                      onChange={handleFileExtract}
                    />
                  </div>
                  <button
                    className="material_add_btn"
                    disabled={phaseName === "" || fileData.name === ""}
                    onClick={() => {
                      setPhasePopupShow(false);
                      handleAddMaterilas();
                    }}
                  >
                    {t("Add")}
                  </button>
                </div>
              )}
              {/* Add Phase Popup end*/}

              <Col xl={3} className="p-0">
                <div
                  onClick={() => {
                    // setImportCadPopup(true);
                  }}
                  className={
                    roleAccess === process.env.REACT_APP_IS_VIEWER
                      ? "pointer d-none position-relative"
                      : "pointer d-flex gap-2 p-3 pb-0 position-relative"
                  }
                  style={{ borderRadius: "8px" }}
                >
                  <img src={shared} className="addDocImg_add" alt="" />
                  <p className="createWork pt-1">
                    {/* Import CAD File */}
                    {t("Import CAD File")}
                  </p>
                </div>
              </Col>

              {/* Add CAD Popup  start*/}
              {importCadPopup && (
                <div className="popup-material-CAD">
                  <div className="d-flex gap-2 justify-content-end">
                    <img
                      src={Xcircle}
                      className="addDocImg_add pointer"
                      alt="Add Icon"
                      onClick={() => {
                        setImportCadPopup(false);
                      }}
                    />
                  </div>

                  <div className="material-input-container" id="materialInput">
                    <label className="material-label-top materialNameText">
                      <span>choose File</span>
                    </label>
                    <input
                      type="text"
                      readOnly
                      className={"materialNameInput ps-4 bordered-inputs"}
                      // value={projectName}
                      placeholder="click to select file from your computer"
                      onChange={(e) => {}}
                      onClick={onAttachemntClick22}
                    />
                    <input
                      type="file"
                      ref={fileRef22}
                      className="d-none"
                      // accept="image/*"
                      // accept=".pdf"
                      // accept=".xls,.xlsx"
                      accept=".cad,.pdf,.xls"
                      onChange={handleFileExtract}
                    />
                  </div>
                  <button className="material_add_btn mt-5">Import</button>
                </div>
              )}
              {/* Add CAD Popup  end*/}

              <Col xl={3} className="p-0 invisible d-none d-xl-block">
                <sortSection
                  className="d-flex gap-3 p-3 pb-0"
                  style={{ position: "relative" }}
                >
                  <p className="sortBy">Sort by</p>
                  <img
                    className={
                      shortByArrow
                        ? "downSortArrow mt-1 pointer"
                        : "upSortArrow mt-1 pointer"
                    }
                    src={upArrow}
                    alt=""
                    onClick={() => {
                      setShortByArrow(!shortByArrow);
                    }}
                  />

                  <p
                    ref={sortByRef}
                    className="datetext pointer"
                    onClick={() => setShowShortDrop(!showShortDrop)}
                  >
                    {sortedValue ? sortedValue : "Select"}
                  </p>

                  <div
                    className="sortDropDiv p-3"
                    style={{
                      transform: showShortDrop ? "scale(1)" : "scale(0)",
                      transitionDuration: "300ms",
                      left: "70px",
                      top: "0px",
                    }}
                  >
                    {sortByOption.map((item, index) => {
                      return (
                        <div
                          className={
                            sortedValue === item.label
                              ? "datetext pointer"
                              : "pointer"
                          }
                          onClick={() => {
                            setSortedValue(item.value);
                            setShowShortDrop(false);
                          }}
                        >
                          <p className="d-flex gap-">
                            {item.label}
                            {sortedValue === item.label && (
                              <p className="mb-0 ps-3">✓</p>
                            )}
                          </p>
                        </div>
                      );
                    })}
                  </div>
                </sortSection>
              </Col>

              <Col xl={3} className="add-col-item pe-0">
                <div className="p-3 pb-0">
                  {/* header pagination start 2nd*/}
                  <section
                    className="fr quotes-div-sec-2 addstock-page-length  addstock-page-in-tablet"
                    style={{ gap: "7px" }}
                  >
                    <p>
                      {pageNumber === 1
                        ? 1
                        : itemsPerPage * (pageNumber - 1) + 1}
                      -
                      {itemsPerPage * pageNumber > totalItems
                        ? totalItems
                        : itemsPerPage * pageNumber}
                    </p>
                    <p>of</p>
                    <p>{totalItems}</p>
                    <p
                      className="aro-lr"
                      onClick={() => {
                        if (pageNumber === 1) return;
                        setPageNumber((p) => p - 1);
                      }}
                    >
                      {"<"}
                    </p>
                    <p className="quote-current-page">{pageNumber}</p>
                    <p
                      className="aro-lr"
                      onClick={() => {
                        if (pageNumber >= totalPages) return;
                        setPageNumber((p) => p + 1);
                      }}
                    >
                      {">"}
                    </p>
                  </section>
                </div>
              </Col>
            </Row>

            <div id="ascSelectBox" className="ascTableWrapper px-4">
              <table className="table">
                <thead>
                  <tr
                    className="tableHeading"
                    style={{
                      color: "#333333",
                      fontSize: "14px",
                      fontWeight: "700",
                    }}
                  >
                    <th style={{ width: "2%" }}></th>
                    <th style={{ width: "15%" }}>
                      {/* Work */}
                      {t("WORK")}
                    </th>
                    <th style={{ width: "12%" }}>
                      {/* Art.No. */}
                      {t("Art No")}
                    </th>
                    <th style={{ width: "30%" }}>
                      {/* Material */}
                      {t("Material")}
                    </th>
                    <th style={{ width: "6%" }}>
                      {/* Kg */}
                      {t("KG")}
                    </th>
                    <th style={{ width: "6%" }}>
                      {/* Qty */}
                      {t("QTY")}
                    </th>
                    <th style={{ width: "6%" }}>
                      {/* Total */}
                      {t("Total")}
                    </th>
                    <th style={{ width: "6%" }}>
                      {/* Order Picked */}
                      {t("Order Picked")}
                    </th>
                    <th style={{ width: "6%" }}></th>
                  </tr>
                </thead>

                <tbody
                  className="tabLine"
                  style={{
                    color: "#333333",
                    fontSize: "14px",
                    fontWeight: "400",
                  }}
                >
                  {materialsList.map((item, index) => {
                    const isMaterialNotExist = item.phaseMaterials.some(
                      (item) => item.productexist === 0,
                    );
                    return (
                      <>
                        <tr
                          className="asc_Table_Hover"
                          // title={item.clientname.length > 10 && item.clientname}
                          onClick={() => {
                            setSelectedPhaseID(item.phaseId);
                          }}
                        >
                          <td className="position-relative ps-3">
                            <img
                              className="pointer"
                              src={Kebab}
                              alt=""
                              onClick={() => {
                                setKebabPopupShow(true);
                              }}
                            />
                            <AnimatePresence>
                              {kebabPopupShow &&
                                item.phaseId === selectedPhaseID && (
                                  <motion.div
                                    // transition={{ duration: 0.5 }}
                                    // whileHover={{ scale: 1.2 }}
                                    // whileTap={{  opacity: 0  }}

                                    // transition={{ duration: 0.5 }}
                                    // initial={{ translateX: -100, opacity: 0 }}
                                    // animate={{
                                    //   translateX: 0,
                                    //   opacity: 1,
                                    //   // transition: {
                                    //   //   duration: 0.5,
                                    //   //   ease: "easeIn",
                                    //   // },
                                    // }}
                                    // exit={{
                                    //   translateX: -100,
                                    //   opacity: 0,
                                    //   // transition: {
                                    //   //   duration: 0.3,
                                    //   //   ease: "easeOut",
                                    //   // },
                                    // }}

                                    initial={{ translateY: -100, opacity: 0 }}
                                    animate={{
                                      translateY: 0,
                                      opacity: 1,
                                      transition: {
                                        duration: 0.5,
                                      },
                                    }}
                                    exit={{
                                      translateY: -100,
                                      opacity: 0,
                                      transition: {
                                        duration: 0.3,
                                      },
                                    }}
                                    // initial={{ height: 0, opacity: 0 }}
                                    // animate={{ height: 'auto', opacity: 1 }}
                                    // exit={{ height: 0, opacity: 0 }}

                                    // initial={{ width: 0, opacity: 0 }}
                                    // animate={{ width: "200px", opacity: 1 }}
                                    // exit={{ width: 0, opacity: 0 }}

                                    // initial={{ opacity: 0 }}
                                    // animate={{ opacity: 1 }}
                                    // exit={{ opacity: 0 }}

                                    className="materialKebabPopup p-3 animate__animate-d animate__slideInDow-n animate__faste-r"
                                  >
                                    <div className="pointer ps-2">
                                      <img
                                        src={Kebab}
                                        alt=""
                                        style={{ rotate: "90deg" }}
                                        onClick={() => {
                                          setKebabPopupShow(false);
                                        }}
                                      />
                                    </div>
                                    <div className="kebabTxt pointer pt-4">
                                      <div
                                        className="d-flex gap-2 position-relative align-items-start mb-1"
                                        style={{
                                          background:
                                            createSublistPopup && "#F1F1F1",
                                          borderRadius:
                                            createSublistPopup && "8px",
                                          cursor:
                                            isMaterialNotExist && "not-allowed",
                                        }}
                                        onClick={() => {
                                          if (isMaterialNotExist) return;
                                          if (item.subList !== 0) {
                                            history.push({
                                              pathname: `/view-materials-sublist/${item.phaseId}`,
                                              state: {
                                                from: "MaterialsList_Screen",
                                                subListAlredayCreated: true,
                                                // materialsSublistData:
                                                //   item.phaseMaterials,
                                                phaseID: item.phaseId,
                                                qtySubList: qtySplitData,
                                                selectedSplit: "Custom",
                                                useList: useListData,
                                              },
                                            });
                                          }

                                          if (item.subList === 0) {
                                            setCreateSublistPopup(
                                              !createSublistPopup,
                                            );
                                          }
                                        }}
                                      >
                                        <img
                                          src={docicons}
                                          alt=""
                                          className="addDocImg_add"
                                        />
                                        <p>
                                          {/* {item.subList === 0
                                            ? "Create sublist"
                                            : "View sublist"} */}

                                          {item.subList === 0
                                            ? t("Create Sublist")
                                            : "View sublist"}
                                        </p>
                                      </div>

                                      {createSublistPopup && (
                                        <div
                                          ref={createSublistPopupRef}
                                          className=""
                                          style={{
                                            width: "500px",
                                            maxWidth: "40vw",
                                            position: "absolute",
                                            left: "210px",
                                            top: "45px",
                                            borderRadius: "8px",
                                            background: "#FAFAFA",
                                            boxShadow: "0px 6px 10px #3B455833",
                                          }}
                                        >
                                          <div className="d-flex p-2 pt-3">
                                            <img
                                              src={XiconCircle}
                                              alt=""
                                              width={18}
                                              className="me-2 addDocImg_add ms-auto"
                                              onClick={() => {
                                                setCreateSublistPopup(false);
                                              }}
                                            />
                                          </div>

                                          <div className="row pt- px-3">
                                            {/* Qty Sblist start */}
                                            <div
                                              className="asc-input-container col-12 col-md-3"
                                              id="ascInput"
                                            >
                                              <label className="asc-label-top ClientNameText ms-2">
                                                {/* Qty.Sublist */}
                                                {t("Qty Sublist")}
                                              </label>
                                              <div
                                                className="asc_Client_Input_Div_For_LongDiv22"
                                                style={{ width: "auto" }}
                                              >
                                                <input
                                                  type="text"
                                                  className="asc_Client_Input_For_Long ps-4 w-75"
                                                  placeholder="Select"
                                                  value={qtySplitData}
                                                  onChange={(e) => {
                                                    setQtySplitData(
                                                      e.target.value,
                                                    );
                                                    setQtySplitDataPopup(true);
                                                  }}
                                                  onFocus={() => {
                                                    setQtySplitDataPopup(true);
                                                    setArrowOptionsRotate4(
                                                      true,
                                                    );
                                                  }}
                                                />

                                                {qtySplitData ? (
                                                  <img
                                                    src={Xicon}
                                                    className="xicon pointer"
                                                    alt=""
                                                    onClick={() => {
                                                      setArrowOptionsRotate4(
                                                        false,
                                                      );
                                                      setQtySplitData("");
                                                      setQtySplitDataID("");
                                                    }}
                                                  />
                                                ) : (
                                                  <img
                                                    src={DownArrowOption}
                                                    className={
                                                      arrowOptionsRotate4
                                                        ? "upArrow"
                                                        : "downArrow"
                                                    }
                                                    alt=""
                                                    onClick={() => {
                                                      setQtySplitDataPopup(
                                                        true,
                                                      );
                                                      setArrowOptionsRotate4(
                                                        true,
                                                      );
                                                    }}
                                                  />
                                                )}

                                                {qtySplitDataPopup && (
                                                  <div
                                                    className="asc_Custom_Select_Outer22 animate__animated animate__fadeIn animate__faster"
                                                    style={{
                                                      width: "90%",
                                                      left: "5px",
                                                    }}
                                                  >
                                                    <p className="asc_Search_Client_Text pt-2 ps-2 d-flex">
                                                      {/* Select... */}
                                                      {t("Select")}
                                                      <span className="ms-auto">
                                                        <img
                                                          src={XiconCircle}
                                                          className="me-2 ms-auto"
                                                          width={16}
                                                          alt=""
                                                          onClick={() => {
                                                            setQtySplitDataPopup(
                                                              false,
                                                            );
                                                            setArrowOptionsRotate4(
                                                              false,
                                                            );
                                                          }}
                                                        />
                                                      </span>
                                                    </p>

                                                    <section
                                                      className="asc_Search_List pt-0 p-3"
                                                      id="ascSelectBox"
                                                    >
                                                      {qtySplitDataList.map(
                                                        (item, index) => {
                                                          return (
                                                            <div
                                                              key={index}
                                                              className=""
                                                              onClick={() => {
                                                                setQtySplitData(
                                                                  item.name,
                                                                );
                                                                setQtySplitDataID(
                                                                  item.id,
                                                                );
                                                                setQtySplitDataPopup(
                                                                  false,
                                                                );
                                                              }}
                                                            >
                                                              {item.name}
                                                            </div>
                                                          );
                                                        },
                                                      )}
                                                      {qtySplitDataList.length ===
                                                        0 && (
                                                        <span className="noDataDisplay">
                                                          {/* No data to display! */}
                                                          {t(
                                                            "No data to display!\n",
                                                          )}
                                                        </span>
                                                      )}
                                                    </section>
                                                  </div>
                                                )}
                                              </div>
                                            </div>
                                            {/* Qty Sublist popup end */}

                                            {/* Split popup start */}
                                            <div
                                              className="asc-input-container col-12 col-md-5"
                                              id="ascInput"
                                            >
                                              <label className="asc-label-top ClientNameText ms-2">
                                                {/* Split */}
                                                {t("Split")}
                                              </label>
                                              <div
                                                className="asc_Client_Input_Div_For_LongDiv22"
                                                style={{ width: "auto" }}
                                              >
                                                <input
                                                  type="text"
                                                  className="asc_Client_Input_For_Long ps-4 w-75"
                                                  placeholder="Select"
                                                  value={splitData}
                                                  onChange={(e) => {
                                                    setSplitData(
                                                      e.target.value,
                                                    );
                                                    setSplitDataPopup(true);
                                                  }}
                                                  onFocus={() => {
                                                    setSplitDataPopup(true);
                                                    setArrowOptionsRotate5(
                                                      true,
                                                    );
                                                  }}
                                                />

                                                {splitData ? (
                                                  <img
                                                    src={Xicon}
                                                    className="xicon pointer"
                                                    alt=""
                                                    onClick={() => {
                                                      setArrowOptionsRotate5(
                                                        false,
                                                      );
                                                      setSplitData("");
                                                      setSplitDataID("");
                                                    }}
                                                  />
                                                ) : (
                                                  <img
                                                    src={DownArrowOption}
                                                    className={
                                                      arrowOptionsRotate5
                                                        ? "upArrow"
                                                        : "downArrow"
                                                    }
                                                    alt=""
                                                    onClick={() => {
                                                      setSplitDataPopup(true);
                                                      setArrowOptionsRotate5(
                                                        true,
                                                      );
                                                    }}
                                                  />
                                                )}

                                                {splitDataPopup && (
                                                  <div
                                                    className="asc_Custom_Select_Outer22 animate__animated animate__slideInDown animate__faster"
                                                    style={{
                                                      width: "95%",
                                                      left: "5px",
                                                    }}
                                                  >
                                                    <p className="asc_Search_Client_Text pt-2 ps-2 d-flex">
                                                      {/* Select... */}
                                                      {t("Select")}
                                                      <span className="ms-auto">
                                                        <img
                                                          src={XiconCircle}
                                                          className="me-2 ms-auto"
                                                          width={16}
                                                          alt=""
                                                          onClick={() => {
                                                            setSplitDataPopup(
                                                              false,
                                                            );
                                                            setArrowOptionsRotate5(
                                                              false,
                                                            );
                                                          }}
                                                        />
                                                      </span>
                                                    </p>

                                                    <section
                                                      className="asc_Search_List pt-0 p-3"
                                                      id="ascSelectBox"
                                                    >
                                                      {splitDataList.map(
                                                        (item, index) => {
                                                          return (
                                                            <div
                                                              key={index}
                                                              className=""
                                                              onClick={() => {
                                                                setSplitData(
                                                                  item.name,
                                                                );
                                                                setSplitDataID(
                                                                  item.id,
                                                                );
                                                                setSplitDataPopup(
                                                                  false,
                                                                );
                                                              }}
                                                            >
                                                              {item.name}
                                                            </div>
                                                          );
                                                        },
                                                      )}
                                                      {splitDataList.length ===
                                                        0 && (
                                                        <span className="noDataDisplay">
                                                          {/* No data to display! */}
                                                          {t(
                                                            "No data to display!\n",
                                                          )}
                                                        </span>
                                                      )}
                                                    </section>
                                                  </div>
                                                )}
                                              </div>
                                            </div>
                                            {/* Split popup end */}

                                            {/* UseList popup start */}
                                            <div
                                              className="asc-input-container col-12 col-md-3"
                                              id="ascInput"
                                            >
                                              <label className="asc-label-top ClientNameText ms-2">
                                                {/* Use List */}
                                                {t("Use List")}
                                              </label>
                                              <div
                                                className="asc_Client_Input_Div_For_LongDiv22 pointerEvent"
                                                style={{ width: "auto" }}
                                              >
                                                <input
                                                  type="text"
                                                  className="asc_Client_Input_For_Long ps-4 w-75"
                                                  placeholder="Select"
                                                  value={useListData}
                                                  onChange={(e) => {
                                                    setUseListData(
                                                      e.target.value,
                                                    );
                                                    setUseListDataPopup(true);
                                                  }}
                                                  onFocus={() => {
                                                    setUseListDataPopup(true);
                                                    setArrowOptionsRotate6(
                                                      true,
                                                    );
                                                  }}
                                                />

                                                {useListData ? (
                                                  <img
                                                    src={Xicon}
                                                    className="xicon pointer"
                                                    alt=""
                                                    onClick={() => {
                                                      setArrowOptionsRotate6(
                                                        false,
                                                      );
                                                      setUseListData("");
                                                      setUseListDataID("");
                                                    }}
                                                  />
                                                ) : (
                                                  <img
                                                    src={DownArrowOption}
                                                    className={
                                                      arrowOptionsRotate6
                                                        ? "upArrow"
                                                        : "downArrow"
                                                    }
                                                    alt=""
                                                    onClick={() => {
                                                      setUseListDataPopup(true);
                                                      setArrowOptionsRotate6(
                                                        true,
                                                      );
                                                    }}
                                                  />
                                                )}

                                                {useListDataPopup && (
                                                  <div
                                                    className="asc_Custom_Select_Outer22 animate__animated animate__slideInDown animate__faster"
                                                    style={{
                                                      width: "90%",
                                                      left: "5px",
                                                    }}
                                                  >
                                                    <p className="asc_Search_Client_Text pt-2 ps-2 d-flex">
                                                      {/* Select... */}
                                                      {t("Select")}
                                                      <span className="ms-auto">
                                                        <img
                                                          src={XiconCircle}
                                                          className="me-2 ms-auto"
                                                          width={16}
                                                          alt=""
                                                          onClick={() => {
                                                            setUseListDataPopup(
                                                              false,
                                                            );
                                                            setArrowOptionsRotate6(
                                                              false,
                                                            );
                                                          }}
                                                        />
                                                      </span>
                                                    </p>

                                                    <section
                                                      className="asc_Search_List pt-0 p-3"
                                                      id="ascSelectBox"
                                                    >
                                                      {useListDataList.map(
                                                        (item, index) => {
                                                          return (
                                                            <div
                                                              key={index}
                                                              className=""
                                                              onClick={() => {
                                                                setUseListData(
                                                                  item.name,
                                                                );
                                                                setUseListDataID(
                                                                  item.id,
                                                                );
                                                                setUseListDataPopup(
                                                                  false,
                                                                );
                                                              }}
                                                            >
                                                              {item.name}
                                                            </div>
                                                          );
                                                        },
                                                      )}
                                                      {useListDataList.length ===
                                                        0 && (
                                                        <span className="noDataDisplay">
                                                          {/* No data to display! */}
                                                          {t(
                                                            "No data to display!\n",
                                                          )}
                                                        </span>
                                                      )}
                                                    </section>
                                                  </div>
                                                )}
                                              </div>
                                            </div>
                                            {/* UseList popup end */}
                                          </div>

                                          <div className="py-5">
                                            <button
                                              id="ascButtonDisabled"
                                              className="button_invo mx-auto"
                                              disabled={splitData === ""}
                                              onClick={(e) => {
                                                setPickStockPopup(false);
                                                history.push({
                                                  pathname: `/materials-sublist/${item.phaseId}`,
                                                  state: {
                                                    from: "MaterialsList_Screen",
                                                    subListAlredayCreated:
                                                      item.subList === 0
                                                        ? false
                                                        : true,
                                                    materialsSublistData:
                                                      item.phaseMaterials,
                                                    phaseID: item.phaseId,
                                                    qtySubList: qtySplitData,
                                                    selectedSplit: splitData,
                                                    useList: useListData,
                                                  },
                                                });
                                              }}
                                            >
                                              <p className="mb-0">
                                                {/* Create */}
                                                {t("Create")}
                                              </p>
                                            </button>
                                          </div>
                                        </div>
                                      )}

                                      <div
                                        className="d-flex gap-2 position-relative align-items-start mb-1"
                                        style={{
                                          background:
                                            pickStockPopup && "#F1F1F1",
                                          borderRadius: pickStockPopup && "8px",
                                          cursor:
                                            isMaterialNotExist && "not-allowed",
                                        }}
                                        onClick={() => {
                                          if (isMaterialNotExist) return;
                                          if (item.subList === 0) {
                                            history.push({
                                              pathname:
                                                "/order-picking-project",
                                              state: {
                                                projectId: projectid,
                                                projectCode: projectcode,
                                                items: item,
                                              },
                                            });
                                          }
                                          setPickStockPopup(!pickStockPopup);
                                        }}
                                      >
                                        <img
                                          src={Package_icon}
                                          alt=""
                                          className="addDocImg_add"
                                        />
                                        <p>
                                          {/* Pick from stock */}
                                          {t("Pick From Stock")}
                                        </p>
                                      </div>

                                      {pickStockPopup && (
                                        <div
                                          ref={pickStockPopupRef}
                                          className="w-100"
                                          style={{
                                            position: "absolute",
                                            left: "210px",
                                            top: "40px",
                                            borderRadius: "8px",
                                          }}
                                        >
                                          <div
                                            className="p-2 text-end"
                                            style={{
                                              background: "#E1E1E1",
                                              borderRadius: "8px 8px 0px 0px",
                                            }}
                                          >
                                            <img
                                              src={XiconCircle}
                                              alt=""
                                              width={16}
                                              className="ms-auto"
                                              onClick={() => {
                                                setPickStockPopup(false);
                                              }}
                                            />
                                          </div>
                                          <div
                                            className="asc_Search_Box w-100 ms- d-flex pointer"
                                            style={{
                                              border: "unset",
                                              background: "white",
                                              height: "40px",
                                              paddingTop: "10px",
                                              borderRadius: "unset",
                                            }}
                                          >
                                            <p
                                              className="asc_Client_Input_For_Long ps-3 m-0"
                                              onClick={() => {
                                                setPickFromStockShow(
                                                  !pickFromStockShow,
                                                );
                                                setArrowOptionsRotate3(
                                                  !arrowOptionsRotate3,
                                                );
                                              }}
                                            >
                                              <p className="m-0 selectedTxT">
                                                {pickFromStock ||
                                                  "Select from stock..."}
                                              </p>
                                            </p>

                                            <img
                                              src={DownArrowOption}
                                              className={
                                                arrowOptionsRotate3
                                                  ? "upArrow mt-1"
                                                  : "downArrow mt-1"
                                              }
                                              alt=""
                                              onClick={() => {
                                                setPickFromStockShow(
                                                  !pickFromStockShow,
                                                );
                                                setArrowOptionsRotate3(
                                                  !arrowOptionsRotate3,
                                                );
                                              }}
                                            />

                                            {pickFromStockShow && (
                                              <div
                                                className="asc_Custom_Select_Outer pt-1"
                                                style={{
                                                  borderTop: "none",
                                                  border: "unset",
                                                  background: "white",
                                                }}
                                              >
                                                <div className="">
                                                  {Array.from(
                                                    { length: totalSubIndex },
                                                    (_, index) => (
                                                      <p
                                                        key={index + 1}
                                                        className={
                                                          pickFromStock ===
                                                          index + 1
                                                            ? "asc_Selected_Item ps-4 mb-2 d-flex justify-content-between"
                                                            : "ps-4 mb-2 hoverItem"
                                                        }
                                                        style={{
                                                          boxShadow: "unset",
                                                        }}
                                                        onClick={() => {
                                                          setPickFromStock(
                                                            index + 1,
                                                          );
                                                          setPickFromStockShow(
                                                            false,
                                                          );
                                                          setArrowOptionsRotate3(
                                                            false,
                                                          );

                                                          history.push({
                                                            pathname:
                                                              "/order-picking-project",
                                                            state: {
                                                              projectId:
                                                                projectid,
                                                              projectCode:
                                                                projectcode,
                                                              items: item,
                                                              selectedSubIndex:
                                                                index,
                                                            },
                                                          });
                                                        }}
                                                      >
                                                        {index + 1}
                                                        {pickFromStock ===
                                                          index + 1 && (
                                                          <p className="m-0 pe-2">
                                                            ✔
                                                          </p>
                                                        )}
                                                      </p>
                                                    ),
                                                  )}
                                                </div>
                                              </div>
                                            )}
                                          </div>
                                        </div>
                                      )}

                                      <div
                                        className="d-flex gap-2 position-relative align-items-start mb-1"
                                        style={{
                                          background:
                                            addPurchasePopup && "#F1F1F1",
                                          borderRadius:
                                            addPurchasePopup && "8px",
                                          cursor:
                                            isMaterialNotExist && "not-allowed",
                                        }}
                                        onClick={() => {
                                          // history.push({
                                          //   pathname: "/add-contact",
                                          //   state: {
                                          //     from: "CompanyList_Screen",
                                          //     companyName: item.clientname,
                                          //   },
                                          // });
                                          if (isMaterialNotExist) return;
                                          setAddPurchasePopup(
                                            !addPurchasePopup,
                                          );
                                        }}
                                      >
                                        <img
                                          src={shoppingCart}
                                          alt=""
                                          className="addDocImg_add"
                                        />
                                        <p>
                                          {/* Add Purchase */}
                                          {t("Add Puchase")}
                                        </p>
                                      </div>

                                      {addPurchasePopup && (
                                        <div
                                          ref={addPurchasePopupRef}
                                          className="w-100"
                                          style={{
                                            position: "absolute",
                                            left: "210px",
                                            top: "40px",
                                            borderRadius: "8px",
                                          }}
                                        >
                                          <div
                                            className="p-2 text-end"
                                            style={{
                                              background: "#E1E1E1",
                                              borderRadius: "8px 8px 0px 0px",
                                            }}
                                          >
                                            <img
                                              src={XiconCircle}
                                              alt=""
                                              width={16}
                                              className="ms-auto"
                                              onClick={() => {
                                                setAddPurchasePopup(false);
                                              }}
                                            />
                                          </div>
                                          <div
                                            // ref={status_Popup_Ref}
                                            className="asc_Search_Box w-100 ms- d-flex pointer"
                                            style={{
                                              border: "unset",
                                              background: "white",
                                              height: "40px",
                                              paddingTop: "10px",
                                              borderRadius: "unset",
                                            }}
                                          >
                                            <p
                                              className="asc_Client_Input_For_Long ps-3 m-0"
                                              onClick={() => {
                                                setAddPurchaseShow(
                                                  !addPurchaseShow,
                                                );
                                                setArrowOptionsRotate7(
                                                  !arrowOptionsRotate7,
                                                );
                                              }}
                                            >
                                              <p className="m-0 selectedTxT">
                                                {/* {addPurchase ||
                                                  "Select purchase list..."} */}

                                                {addPurchase ||
                                                  t("Select Purchase List")}
                                              </p>
                                            </p>

                                            <img
                                              src={DownArrowOption}
                                              className={
                                                arrowOptionsRotate7
                                                  ? "upArrow mt-1"
                                                  : "downArrow mt-1"
                                              }
                                              alt=""
                                              onClick={() => {
                                                setAddPurchaseShow(
                                                  !addPurchaseShow,
                                                );
                                                setArrowOptionsRotate7(
                                                  !arrowOptionsRotate7,
                                                );
                                              }}
                                            />

                                            {addPurchaseShow && (
                                              <div
                                                className="asc_Custom_Select_Outer pt-1"
                                                style={{
                                                  borderTop: "none",
                                                  border: "unset",
                                                  background: "white",
                                                }}
                                              >
                                                <div className="">
                                                  <p
                                                    className={
                                                      addPurchase === "1"
                                                        ? "asc_Selected_Item ps-4 mb-2 d-flex justify-content-between"
                                                        : "ps-4 mb-2 hoverItem"
                                                    }
                                                    style={{
                                                      boxShadow: "unset",
                                                    }}
                                                    onClick={() => {
                                                      setAddPurchase("1");
                                                      setAddPurchaseShow(false);
                                                      setArrowOptionsRotate7(
                                                        false,
                                                      );
                                                    }}
                                                  >
                                                    1
                                                    {addPurchase === "1" && (
                                                      <p className="m-0 pe-2">
                                                        ✔
                                                      </p>
                                                    )}
                                                  </p>
                                                  <p
                                                    className={
                                                      addPurchase === "2"
                                                        ? "asc_Selected_Item ps-4 mb-1 d-flex justify-content-between"
                                                        : "ps-4 mb-3 hoverItem"
                                                    }
                                                    style={{
                                                      boxShadow: "unset",
                                                    }}
                                                    onClick={() => {
                                                      setAddPurchase("2");
                                                      setAddPurchaseShow(false);
                                                      setArrowOptionsRotate7(
                                                        false,
                                                      );
                                                    }}
                                                  >
                                                    2
                                                    {addPurchase === "2" && (
                                                      <p className="m-0 pe-2">
                                                        ✔
                                                      </p>
                                                    )}
                                                  </p>
                                                </div>
                                              </div>
                                            )}
                                          </div>
                                        </div>
                                      )}

                                      <div
                                        className="d-flex gap-2 position-relative align-items-start mb-1"
                                        style={{
                                          background:
                                            makeCheckListPopup && "#F1F1F1",
                                          borderRadius:
                                            makeCheckListPopup && "8px",
                                          cursor:
                                            isMaterialNotExist && "not-allowed",
                                        }}
                                        onClick={() => {
                                          // history.push({
                                          //   pathname: "/add-contact",
                                          //   state: {
                                          //     from: "CompanyList_Screen",
                                          //     companyName: item.clientname,
                                          //   },
                                          // });
                                          if (isMaterialNotExist) return;
                                          setMakeCheckListPopup(
                                            !makeCheckListPopup,
                                          );
                                        }}
                                      >
                                        <img
                                          src={pdf_icon}
                                          alt=""
                                          className="addDocImg_add"
                                        />
                                        <p>
                                          {/* Make Checklist */}
                                          {t("Make Checklist")}
                                        </p>
                                      </div>

                                      {makeCheckListPopup && (
                                        <div
                                          ref={makeCheckListPopupRef}
                                          className="w-100"
                                          style={{
                                            position: "absolute",
                                            left: "210px",
                                            top: "40px",
                                            borderRadius: "8px",
                                          }}
                                        >
                                          <div
                                            className="p-2 text-end"
                                            style={{
                                              background: "#E1E1E1",
                                              borderRadius: "8px 8px 0px 0px",
                                            }}
                                          >
                                            <img
                                              src={XiconCircle}
                                              alt=""
                                              width={16}
                                              className="ms-auto"
                                              onClick={() => {
                                                setMakeCheckListPopup(false);
                                              }}
                                            />
                                          </div>
                                          <div
                                            // ref={status_Popup_Ref}
                                            className="asc_Search_Box w-100 ms- d-flex pointer"
                                            style={{
                                              border: "unset",
                                              background: "white",
                                              height: "40px",
                                              paddingTop: "10px",
                                              borderRadius: "unset",
                                            }}
                                          >
                                            <p
                                              className="asc_Client_Input_For_Long ps-3 m-0"
                                              onClick={() => {
                                                setMakeCheckListShow(
                                                  !makeCheckListShow,
                                                );
                                                setArrowOptionsRotate8(
                                                  !arrowOptionsRotate8,
                                                );
                                              }}
                                            >
                                              <p className="m-0 selectedTxT">
                                                {/* {makeCheckList ||
                                                  "Select checklist..."} */}

                                                {makeCheckList ||
                                                  t("Select Checklist")}
                                              </p>
                                            </p>

                                            <img
                                              src={DownArrowOption}
                                              className={
                                                arrowOptionsRotate8
                                                  ? "upArrow mt-1"
                                                  : "downArrow mt-1"
                                              }
                                              alt=""
                                              onClick={() => {
                                                setMakeCheckListShow(
                                                  !makeCheckListShow,
                                                );
                                                setArrowOptionsRotate8(
                                                  !arrowOptionsRotate8,
                                                );
                                              }}
                                            />

                                            {makeCheckListShow && (
                                              <div
                                                className="asc_Custom_Select_Outer pt-1"
                                                style={{
                                                  borderTop: "none",
                                                  border: "unset",
                                                  background: "white",
                                                }}
                                              >
                                                <div className="">
                                                  <p
                                                    className={
                                                      makeCheckList === "1"
                                                        ? "asc_Selected_Item ps-4 mb-2 d-flex justify-content-between"
                                                        : "ps-4 mb-2 hoverItem"
                                                    }
                                                    style={{
                                                      boxShadow: "unset",
                                                    }}
                                                    onClick={() => {
                                                      setMakeCheckList("1");
                                                      setMakeCheckListShow(
                                                        false,
                                                      );
                                                      setArrowOptionsRotate8(
                                                        false,
                                                      );
                                                    }}
                                                  >
                                                    1
                                                    {makeCheckList === "1" && (
                                                      <p className="m-0 pe-2">
                                                        ✔
                                                      </p>
                                                    )}
                                                  </p>
                                                  <p
                                                    className={
                                                      makeCheckList === "2"
                                                        ? "asc_Selected_Item ps-4 mb-1 d-flex justify-content-between"
                                                        : "ps-4 mb-3 hoverItem"
                                                    }
                                                    style={{
                                                      boxShadow: "unset",
                                                    }}
                                                    onClick={() => {
                                                      setMakeCheckList("2");
                                                      setMakeCheckListShow(
                                                        false,
                                                      );
                                                      setArrowOptionsRotate8(
                                                        false,
                                                      );
                                                    }}
                                                  >
                                                    2
                                                    {makeCheckList === "2" && (
                                                      <p className="m-0 pe-2">
                                                        ✔
                                                      </p>
                                                    )}
                                                  </p>
                                                </div>
                                              </div>
                                            )}
                                          </div>
                                        </div>
                                      )}

                                      <div
                                        className="d-flex gap-2 position-relative align-items-start mb-1"
                                        style={{
                                          // background: pickStockPopup && "#F1F1F1",
                                          // borderRadius: pickStockPopup && "8px",
                                          cursor:
                                            isMaterialNotExist && "not-allowed",
                                        }}
                                        onClick={() => {
                                          // history.push({
                                          //   pathname: "/add-contact",
                                          //   state: {
                                          //     from: "CompanyList_Screen",
                                          //     companyName: item.clientname,
                                          //   },
                                          // });
                                          // setPickStockPopup(!pickStockPopup);
                                          // setCreateSublistPopup(false);
                                          if (isMaterialNotExist) return;
                                        }}
                                      >
                                        <img
                                          src={printimg}
                                          alt=""
                                          className="addDocImg_add"
                                        />
                                        <p>
                                          {/* Print */}
                                          {t("Print")}
                                        </p>
                                      </div>

                                      <div
                                        className="d-flex gap-2 align-items-start"
                                        // style={{
                                        //   cursor:
                                        //     isMaterialNotExist && "not-allowed",
                                        // }}
                                        onClick={() => {
                                          // history.push({
                                          //   pathname: "/addProject",
                                          //   state: "/project",
                                          //   ascState: {
                                          //     from: "CompanyList_Screen",
                                          //     clientName: item.clientname,
                                          //     clientId: item.clientid,
                                          //   },
                                          // });
                                          // if (isMaterialNotExist) return;
                                          dispatch(DeletePhase(item.phaseId));
                                        }}
                                      >
                                        <img
                                          src={bin}
                                          alt=""
                                          className="addDocImg_add"
                                        />
                                        <p>
                                          {/* Remove */}
                                          {t("Remove")}
                                        </p>
                                      </div>
                                    </div>
                                  </motion.div>
                                )}
                            </AnimatePresence>
                          </td>
                          <td
                            // title={item?.workname?.length > 10 && item?.workname}
                            className="pointer"
                            // style={{
                            //   // for 3 dots 👇
                            //   // whiteSpace: "pre-wrap",
                            //   whiteSpace: "nowrap",
                            //   overflow: "hidden",
                            //   textOverflow: "ellipsis",
                            //   maxWidth: "10px",
                            // }}
                            onClick={() => {
                              setIsUpdateTime(true);
                            }}
                          >
                            {item.phaseName}
                          </td>

                          {/* <td className="">
                          {moment(item.createdat).format("DD.MM.YYYY")}
                        </td> */}

                          <td>{item.ordercode}</td>

                          <td
                            className=""
                            // title={
                            //   item.suppliername.length > 10 && item.suppliername
                            // }
                            style={{
                              // for 3 dots 👇
                              // whiteSpace: "pre-wrap",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              maxWidth: "10px",
                            }}
                          >
                            {item.asc}
                          </td>

                          <td className="">
                            {/* {europeanFormatWithSymbol(item.asc)} */}
                            {/* {item.unit} */}
                          </td>

                          <td className="">
                            {/* {moment(item.asc).format("DD.MM.YYYY")} */}
                            {/* {item.quantity} */}

                            {item.subList === 0
                              ? item.quantity
                              : xlExtractDataPopup &&
                                  item.phaseId === selectedPhaseID
                                ? subtotalQty
                                : // : "—"
                                  item.quantity}
                          </td>

                          <td className="">
                            {/* {item.total} */}

                            {item.subList === 0
                              ? item.total
                              : xlExtractDataPopup &&
                                  item.phaseId === selectedPhaseID
                                ? subtotal2
                                : // : "—"
                                  item.total}
                          </td>

                          <td className="ps-5">
                            {item.isOrderPick === 1 ? "Yes" : ""}
                          </td>

                          <td className="ps-5">
                            <img
                              src={DownArrowOption}
                              alt="DownArrowOption"
                              className={
                                xlExtractDataPopup &&
                                item.phaseId === selectedPhaseID
                                  ? "upArrow mt-1 pointer"
                                  : "downArrow mt-1 pointer"
                              }
                              style={{ width: "18px" }}
                              onClick={() => {
                                setXlExtractDataPopup(!xlExtractDataPopup);
                              }}
                            />
                          </td>
                        </tr>

                        {/* Additional Row start*/}
                        <AnimatePresence>
                          {xlExtractDataPopup &&
                            item.phaseId === selectedPhaseID &&
                            // <tr>
                            //   <td colSpan={12} className="details-row">
                            //     <table className="nested-table">
                            //       <thead>
                            //         <tr>
                            //           <th>Material Name</th>
                            //           <th>Article Number</th>
                            //           <th>Quantity</th>
                            //           <th>Total</th>
                            //         </tr>
                            //       </thead>
                            //       <tbody>
                            //         {item.phaseMaterials.map((x) => (
                            //           <tr key={x.id}>
                            //             <td>{x.materialName}</td>
                            //             <td>{x.articalNumber}</td>
                            //             <td>{x.quantity}</td>
                            //             <td>{x.total}</td>
                            //           </tr>
                            //         ))}
                            //       </tbody>
                            //     </table>
                            //   </td>
                            // </tr>

                            (item.subList === 0 ? (
                              <XlExtractUnderData
                                underData={item.phaseMaterials}
                                phaseID={item.phaseId}
                                subListAlredayCreated={
                                  item.subList === 0 ? false : true
                                }
                                setFetchTranslationList={
                                  setFetchTranslationList
                                }
                                FetchTranslationList={FetchTranslationList}
                              />
                            ) : (
                              <SubListCreatedData
                                phaseID={item.phaseId}
                                subListAlredayCreated={
                                  item.subList === 0 ? false : true
                                }
                                setSubtotalQty={setSubtotalQty}
                                setSubtotal2={setSubtotal2}
                                setFetchTranslationList={
                                  setFetchTranslationList
                                }
                                FetchTranslationList={FetchTranslationList}
                              />
                            ))}
                        </AnimatePresence>
                        {/* Additional Row end*/}
                      </>
                    );
                  })}
                  {materialsList.length === 0 && (
                    <span className="noDataDisplay">
                      {/* No data to display! */}
                      {t("No data to display!\n")}
                    </span>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

const XlExtractUnderData = ({ underData, phaseID, FetchTranslationList }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const t = (key) => FetchTranslationList?.[key] || "";

  const HtmlTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: "#FFFFFF",
      color: "rgba(0, 0, 0, 0.87)",
      width: theme.typography.pxToRem(130),
      height: theme.typography.pxToRem(49),
      fontSize: theme.typography.pxToRem(12),
      // fontSize: 12,
      boxShadow: theme.shadows[2],
    },
  }));

  const [selectedBox, setSelectedBox] = useState([]);

  // ASC pagination start 👇.
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;

  // Calculate total pages
  const totalPages = Math.ceil(underData.length / itemsPerPage);

  // Get the current page's data
  const currentData = underData.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage,
  );

  // Handle navigation
  const goToNextPage = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };

  const goToPreviousPage = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };
  // ASC pagination end 👆.

  return (
    <motion.tr
      initial={{ translateY: -30, opacity: 0 }}
      animate={{
        translateY: 0,
        opacity: 1,
        transition: {
          duration: 0.5,
        },
      }}
      exit={{
        translateY: -100,
        opacity: 0,
        transition: {
          duration: 0.3,
        },
      }}
      // className="animate__animated animate__fadeIn"
    >
      <td colSpan={12} className="details-row">
        <table className="nested-table">
          <thead>
            <tr>
              <th style={{ width: "0%" }}></th>
              <th style={{ width: "17%" }}>
                {/* List &nbsp; */}
                {t("List")} &nbsp;
                <div className="d-flex align-items-center d-none">
                  {/* List &nbsp; */}
                  {t("List")} &nbsp;
                  <button
                    className="ms-1"
                    onClick={goToPreviousPage}
                    disabled={currentPage === 1}
                    style={{ border: "none", background: "unset" }}
                  >
                    <h4 className="mb-1">{"<"}</h4>
                  </button>
                  <span>
                    {/* &nbsp;{currentPage} of {totalPages} */}
                    &nbsp;{currentPage}
                    {/* if we need like 1-10 of <1> 👇 */}
                    {/* {startIndex}-{endIndex} of {underData.length} &nbsp;
                    {`(<${currentPage}>)`} */}
                  </span>
                  <button
                    className="ms-1"
                    onClick={goToNextPage}
                    disabled={currentPage === totalPages}
                    style={{ border: "none", background: "unset" }}
                  >
                    <h4 className="mb-1">{">"}</h4>
                  </button>
                  of {totalPages}
                </div>
              </th>
              <th
                className="pointer ps-1 align-middle"
                style={{ width: "14%" }}
                onClick={() => {
                  dispatch(DeletePhase(phaseID));
                }}
              >
                <img src={bin} alt="" className="" style={{ width: "16px" }} />
                <span className="pt-1 ps-1">
                  {/* Remove List */}
                  {t("Remove List")}
                </span>
              </th>
              <th style={{ verticalAlign: "middle", width: "35%" }}>
                {/* Material */}
                {t("Material")}
              </th>
              <th style={{ verticalAlign: "middle", width: "7%" }}>
                {/* Kg */}
                {t("KG")}
              </th>
              <th style={{ verticalAlign: "middle", width: "7%" }}>Qty</th>
              <th style={{ verticalAlign: "middle", width: "7%" }}>Total</th>
              <th style={{ verticalAlign: "middle", width: "13%" }}>
                {/* Remove item */}
                {t("Remove List")}
              </th>
              <th className="align-middle">
                <img
                  src={bin}
                  alt=""
                  className="ms-1 pointer"
                  style={{ width: "16px" }}
                  onClick={() => {
                    let material = selectedBox.map((x) => ({
                      materialid: x.asc_BoxID,
                    }));
                    dispatch(DeleteMaterials(material));
                  }}
                />
              </th>
            </tr>
          </thead>
          <tbody>
            {underData.map((item) => (
              <tr key={item.materialId}>
                <td></td>
                <td></td>
                <td>{item.articalNumber || "—"}</td>
                <td
                  title={item?.materialName?.length > 30 && item?.materialName}
                  style={{
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    maxWidth: "10px",
                    color: item.productexist === 0 && "red",
                    cursor: item.productexist === 0 && "pointer",
                  }}
                  onClick={() => {
                    if (item.productexist !== 0) {
                      return;
                    } else {
                      history.push({
                        pathname: "/add-part",
                        state: {
                          productType: 1,
                          articleNumber: item.articalNumber,
                          materialName: item.materialName,
                        },
                      });
                    }
                  }}
                >
                  {item.materialName || "—"}
                  {item.productexist === 0 && (
                    <HtmlTooltip
                      placement="top"
                      title={
                        <React.Fragment>
                          <div>
                            <label>This item is not exist.</label>
                          </div>
                        </React.Fragment>
                      }
                    >
                      <img src={Attention} alt="" className="ms-2" />
                    </HtmlTooltip>
                  )}
                </td>
                <td>{item.unit || "—"}</td>
                <td className="ps-3">{item.quantity || "—"}</td>
                <td className="ps-3">{item.total || "—"}</td>
                <td className="ps-5">{item.isDelete === 0 ? "No" : "—"}</td>
                <td>
                  <div>
                    <label className="asc-label-top projectNameText d-none">
                      Need PO ?
                    </label>
                    <div className="ps-2 assign_Probability_project gap-3">
                      <div className="mt-2 d-flex align-items-center gap-1 assignment_radio">
                        <input
                          type="checkbox"
                          className="form-check-input pointer companyRadio"
                          // checked={deleted === true}
                          // checked={selectedId === x.materialId}
                          checked={selectedBox.find(
                            (x) => x?.asc_BoxID === item.materialId,
                          )}
                          style={{
                            fontSize: "12px",
                            width: "15px",
                            height: "15px",
                            border: "1px solid",
                            borderRadius: "3px",
                          }}
                          // value={isDeleted}
                          onChange={(e) => {
                            // setDeleted(e.target.checked);
                            // setDeleted(true);
                            // setSelectedId(x.materialId);
                          }}
                          onClick={() => {
                            let index2 = selectedBox.findIndex(
                              (x) => x?.asc_BoxID === item.materialId,
                            );

                            if (index2 !== -1) {
                              let data = [...selectedBox];
                              data.splice(index2, 1);
                              setSelectedBox(data);
                              return;
                            }

                            // start item pushing...
                            let invoiceListArray = [...selectedBox];
                            invoiceListArray.push({
                              asc_BoxName: item.materialName,
                              asc_BoxID: item.materialId,
                            });
                            setSelectedBox(invoiceListArray);
                          }}
                        />
                        {/* Yes */}
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
            ))}
            {currentData.length === 0 && (
              <span className="noDataDisplay">
                {/* No data to display! */}
                {t("No data to display!\n")}
              </span>
            )}
          </tbody>
        </table>
      </td>
    </motion.tr>
  );
};

// when subList Created
const SubListCreatedData = ({
  phaseID,
  setSubtotalQty,
  setSubtotal2,
  FetchTranslationList,
}) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [materialsSublistData, setMaterialsSublistData] = useState([]);
  const [fileName, setFileName] = useState("");
  const [fileSize, setFileSize] = useState("");
  const [phaseName, setPhaseName] = useState("");
  const [quantity, setQuantity] = useState("");
  const [total, setTotal] = useState("");
  const [unit, setUnit] = useState("");
  const [isOrderPick, setIsOrderPick] = useState(false);
  const t = (key) => FetchTranslationList?.[key] || "";

  const fetchMaterialListRes = useSelector(
    (state) => state.user.fetchMaterialListRes,
  );

  useEffect(() => {
    dispatch(FetchMaterialList(phaseID));
  }, []);

  useEffect(() => {
    if (fetchMaterialListRes.status === true) {
      setMaterialsSublistData(fetchMaterialListRes.data[0].phaseMaterials);
      setFileName(fetchMaterialListRes.data[0].fileName);
      setFileSize(fetchMaterialListRes.data[0].fileSize);
      setPhaseName(fetchMaterialListRes.data[0].phaseName);
      setQuantity(fetchMaterialListRes.data[0].quantity);
      setTotal(fetchMaterialListRes.data[0].total);
      setUnit(fetchMaterialListRes.data[0].unit);
      setIsOrderPick(fetchMaterialListRes.data[0].isOrderPick);
      // setShowLoader(false);
    }
  }, [fetchMaterialListRes]);

  const [selectedBox, setSelectedBox] = useState([]);

  // ASC pagination start 👇.
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 1;
  const totalIndex = Math.ceil(
    materialsSublistData[0]?.materialQuantity.length / itemsPerPage,
  );

  const goToNextPage = () => {
    if (currentPage < totalIndex) {
      setCurrentPage(currentPage + 1);
      setSelectedIndex(selectedIndex + 1);
    }
  };

  const goToPreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
      setSelectedIndex(selectedIndex - 1);
    }
  };
  // ASC pagination end 👆.

  const [selectedIndex, setSelectedIndex] = useState(0);

  // sum total of indexQty👇
  const SubtotalofQty = materialsSublistData?.reduce((total, item) => {
    const materialQuantityData = item.materialQuantity[selectedIndex];

    // Calculate the subtotal for the current column
    let subtotal = 0;
    if (Array.isArray(materialQuantityData)) {
      // Sum all quantities if it's an array
      subtotal = materialQuantityData.reduce(
        (sum, x) => sum + (parseFloat(x.quantity) || 0),
        0,
      );
    } else if (
      materialQuantityData &&
      typeof materialQuantityData === "object"
    ) {
      // If it's a single object, just add its quantity
      subtotal = parseFloat(materialQuantityData.quantity || 0);
    }

    // Add the subtotal of this item to the total
    return total + subtotal;
  }, 0);

  // Update the parent component with the subtotalQty
  useEffect(() => {
    setSubtotalQty(SubtotalofQty);
  }, [SubtotalofQty]);

  ////////////////////////////////////////////////////////////

  // sum total of index Total👇
  const SubtotalofTotal = materialsSublistData?.reduce((total, item) => {
    const materialQuantityData = item.materialQuantity[selectedIndex];

    // Calculate the subtotal for the current column
    let subtotal = 0;
    if (Array.isArray(materialQuantityData)) {
      // Sum all quantities if it's an array
      subtotal = materialQuantityData.reduce(
        (sum, x) => sum + Math.round(item.unit * (parseFloat(x.quantity) || 0)),
        0,
      );
    } else if (
      materialQuantityData &&
      typeof materialQuantityData === "object"
    ) {
      // If it's a single object, just add its quantity
      subtotal = Math.round(
        item.unit * (parseFloat(materialQuantityData.quantity) || 0),
      );
    }

    // Add the subtotal of this item to the total
    return total + subtotal;
  }, 0);

  // Update the parent component with the subtotal2
  useEffect(() => {
    setSubtotal2(SubtotalofTotal);
  }, [SubtotalofTotal]);

  return (
    <motion.tr
      initial={{ translateY: -30, opacity: 0 }}
      animate={{
        translateY: 0,
        opacity: 1,
        transition: {
          duration: 0.5,
        },
      }}
      exit={{
        translateY: -100,
        opacity: 0,
        transition: {
          duration: 0.3,
        },
      }}
      // className="animate__animated animate__fadeIn"
    >
      <td colSpan={12} className="details-row">
        <table className="nested-table">
          <thead>
            <tr>
              <th style={{ width: "0%" }}></th>
              <th style={{ width: "17%" }}>
                <div className="d-flex align-items-center">
                  List &nbsp;
                  <button
                    className="ms-1"
                    onClick={goToPreviousPage}
                    disabled={currentPage === 1}
                    style={{ border: "none", background: "unset" }}
                  >
                    <h4 className="mb-1">{"<"}</h4>
                  </button>
                  <span>{currentPage}</span>
                  <button
                    className="ms-"
                    onClick={goToNextPage}
                    disabled={currentPage === totalIndex}
                    style={{ border: "none", background: "unset" }}
                  >
                    <h4 className="mb-1">{">"}</h4>
                  </button>
                  of {totalIndex}
                </div>
              </th>
              <th
                className="pointer ps-1 align-middle"
                style={{ width: "14%" }}
                onClick={() => {
                  dispatch(DeletePhase(phaseID));
                }}
              >
                <img src={bin} alt="" className="" style={{ width: "16px" }} />
                <span className="pt-1 ps-1">
                  {/* Remove List */}
                  {t("Remove List")}
                </span>
              </th>
              <th style={{ verticalAlign: "middle", width: "35%" }}>
                {/* Material */}
                {t("Material")}
              </th>
              <th style={{ verticalAlign: "middle", width: "7%" }}>
                {/* Kg */}
                {t("KG")}
              </th>
              <th style={{ verticalAlign: "middle", width: "7%" }}>
                {/* Qty */}
                {t("QTY")}
              </th>
              <th style={{ verticalAlign: "middle", width: "7%" }}>
                {/* Total */}
                {t("Total")}
              </th>
              <th style={{ verticalAlign: "middle", width: "13%" }}>
                {/* Remove item */}
                {t("Remove Item")}
              </th>
              <th className="align-middle">
                <img
                  src={bin}
                  alt=""
                  className="ms-1 pointer"
                  style={{ width: "16px" }}
                  onClick={() => {
                    let material = selectedBox.map((x) => ({
                      materialid: x.asc_BoxID,
                      // materialid: x.asc_createdSubListID,
                    }));
                    dispatch(DeleteMaterials(material));
                  }}
                />
              </th>
            </tr>
          </thead>
          <tbody>
            {materialsSublistData.map((item, index) => {
              const materialQuantityData = item.materialQuantity[selectedIndex];
              return (
                <tr
                  style={{
                    color: item.productexist === 0 && "red",
                    cursor: item.productexist === 0 && "pointer",
                  }}
                  key={item.materialId}
                  onClick={() => {
                    if (item.productexist === 0) {
                      history.push({
                        pathname: "/add-part",
                        state: {
                          productType: 0,
                          articleNumber: item.articalNumber,
                          materialName: item.materialName,
                        },
                      });
                    }
                  }}
                >
                  <td></td>
                  <td></td>
                  <td>{item.articalNumber || "—"}</td>
                  <td
                    title={
                      item?.materialName?.length > 30 && item?.materialName
                    }
                    style={{
                      // for 3 dots 👇
                      // whiteSpace: "pre-wrap",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      maxWidth: "10px",
                    }}
                  >
                    {item.materialName || "—"}
                  </td>
                  <td>{item.unit || "—"}</td>
                  <td className="ps-3">
                    {materialQuantityData?.quantity || "—"}
                  </td>
                  <td className="ps-3">
                    {/* {item.total || "—"} */}
                    {Math.round(item.unit * materialQuantityData?.quantity) ||
                      "—"}
                  </td>
                  <td className="ps-5">{item.isDelete === 0 ? "No" : "—"}</td>
                  <td>
                    <div>
                      <label className="asc-label-top projectNameText d-none">
                        Need PO ?
                      </label>
                      <div className="ps-2 assign_Probability_project gap-3">
                        <div className="mt-2 d-flex align-items-center gap-1 assignment_radio">
                          <input
                            type="checkbox"
                            className="form-check-input pointer companyRadio"
                            // checked={deleted === true}
                            // checked={selectedId === x.materialId}
                            checked={selectedBox.find(
                              (x) => x?.asc_BoxID === item.materialId,
                            )}
                            style={{
                              fontSize: "12px",
                              width: "15px",
                              height: "15px",
                              border: "1px solid",
                              borderRadius: "3px",
                            }}
                            // value={isDeleted}
                            onChange={(e) => {
                              // setDeleted(e.target.checked);
                              // setDeleted(true);
                              // setSelectedId(x.materialId);
                            }}
                            onClick={() => {
                              let index2 = selectedBox.findIndex(
                                (x) => x?.asc_BoxID === item.materialId,
                              );

                              if (index2 !== -1) {
                                let data = [...selectedBox];
                                data.splice(index2, 1);
                                setSelectedBox(data);
                                return;
                              }

                              // start item pushing...
                              let invoiceListArray = [...selectedBox];
                              invoiceListArray.push({
                                asc_BoxName: item.materialName,
                                asc_BoxID: item.materialId,
                                asc_createdSubListID:
                                  materialQuantityData.materialQuantityid,
                              });
                              setSelectedBox(invoiceListArray);
                            }}
                          />
                          {/* Yes */}
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
              );
            })}
            {materialsSublistData.length === 0 && (
              <span className="noDataDisplay">
                {/* No data to display! */}
                {t("No data to display!\n")}
              </span>
            )}
          </tbody>
        </table>
      </td>
    </motion.tr>
  );
};

export default AddMaterials;
